export default __webpack_public_path__ + "static/media/pgmico.75e0a77d.png";